import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export interface Props {
  msg?: string;
  stretch?: boolean;
  inverse?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Loader',
  props: {
    msg: { default: "" },
    stretch: { type: Boolean },
    inverse: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

__expose({
  props,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader-wrapper", {
      stretched: __props.stretch,
      inverse: __props.inverse,
    }])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dot-floating" }, null, -1))
  ], 2))
}
}

})